





















import Vue from 'vue';
import { BButton } from 'bootstrap-vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'WorkflowsZeroState',
  components: {
    BButton,
  },
  props: {
    objectType: {
      type: String,
      default: '',
    },
    blockTitle: {
      type: String,
      default: '',
    },
    thereAreNoText: {
      type: String,
      required: true,
    },
    clickToAddText: {
      type: String,
      required: true,
    },
    addBtnTitle: {
      type: String,
      required: true,
    },
    addBtnLabel: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['featureFlags']),
    canAdd() {
      return this.featureFlags.extended_workflows_phase2;
    },
  },
  methods: {
    addButtonClicked() {
      this.$emit('add-btn-clicked');
    },
  },
});
